/* eslint-disable @typescript-eslint/naming-convention */
import { IProvidersQuotationResponse } from '@common/interfaces';
import { ILineItemCurrency, ISelectedItems } from '@common/interfaces/Common';
import { sortBy } from 'lodash';

interface DestinationBlock {
  uuid: string;
  name: string;
  providers: any;
  order: any;
}

const combineBySummingKeys = (objA: any, objB: any) => {
  const mergedObj: any = {};

  Object.keys(objA).forEach((key) => {
    mergedObj[key] = objA[key] + (objB[key] || 0);
  });

  Object.keys(objB)
    .filter((key) => mergedObj[key] === undefined)
    // eslint-disable-next-line no-return-assign
    .forEach((key) => (mergedObj[key] = objB[key]));

  return mergedObj;
};

const getCurrencies = (data: IProvidersQuotationResponse): ILineItemCurrency | null => {
  if (data) {
    return data.providers_quotations_overview.reduce((aggregator, element) => {
      return {
        ...aggregator,
        [element.provider_legal_name]: element.currency_iso_code,
      };
    }, {});
  }
  return null;
};

const getDestinations = (
  data: IProvidersQuotationResponse | undefined,
  selectedLineItems: ISelectedItems,
) => {
  const destinations: Array<DestinationBlock> = [];

  if (data) {
    const sortedData = sortBy(
      Object.values(data.quotations_for_line_item),
      ['line_item_order_number'],
      ['asc'],
    );
    sortedData.forEach((item, quotationKey) => {
      const { line_item_destination, line_item_order_number } = item;

      const providers: any = {};
      Object.keys(item).forEach((k) => {
        const selectedItem = selectedLineItems[k] || [];

        if (
          k !== 'line_item_destination' &&
          ((item[k].selected && !data.is_assignment_possible) ||
            selectedItem.includes(quotationKey))
        ) {
          const count = providers[k] ? providers[k] : 0;
          providers[k] = count + item[k].quote;
        }
      });

      const itemIndex = destinations.findIndex(
        (destination) => destination.uuid === line_item_destination.uuid,
      );

      if (itemIndex === -1 && line_item_destination) {
        destinations.push({
          uuid: line_item_destination.uuid,
          name: line_item_destination.name,
          order: line_item_order_number,
          providers,
        });
      } else {
        const prevItem = destinations[itemIndex];
        if (prevItem) {
          destinations[itemIndex].providers = combineBySummingKeys(
            { ...prevItem.providers },
            providers,
          );
        }
      }
    });
  }

  return destinations;
};

export { getCurrencies, getDestinations };
